<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title>Coordinate: {{ lat }}, {{ lng }}</v-card-title>
      <v-card-text>
        <Map v-if="lat && lng" :lat="lat" :lng="lng" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeDelete()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Map from "./Map";

export default {
  props: {
    show: Boolean,
    lat: [Number],
    lng: [Number],
  },
  name: "MyAwesomeMap",

  data() {
    return {
      dialog: false,
    };
  },
  components: {
    Map,
  },
  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  methods: {
    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },
    onDialogClose() {
      this.closeDelete();
    },
    onDialogOpen() {},
  },
};
</script>